// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.RichText_scroll__2JakK::-webkit-scrollbar {
  height: 8px;
}
.RichText_scroll__2JakK::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.RichText_scroll__2JakK::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.RichText_RichText__Aeod3 {
  height: -webkit-fit-content;
  height: fit-content;
}
.RichText_RichText__Aeod3:focus-within label {
  color: var(--secondaryColor);
}
.RichText_RichText__Aeod3:focus-within label.RichText_LabelError__KEPk- {
  color: var(--errorColor);
}
.RichText_RichText__Aeod3 .RichText_LabelError__KEPk- {
  color: var(--errorColor);
}
.RichText_RichText__Aeod3 .RichText_label_required__7\\+MBb {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 10;
}
.RichText_RichText__Aeod3 .RichText_label_required__7\\+MBb label,
.RichText_RichText__Aeod3 .RichText_label_required__7\\+MBb p {
  margin-bottom: 10px;
  font-size: 12px !important;
  line-height: 15px;
}
.RichText_RichText__Aeod3 .RichText_label_required__7\\+MBb label {
  text-transform: capitalize;
}
.RichText_RichText__Aeod3 .RichText_label_required__7\\+MBb p {
  color: var(--errorColor);
}
.RichText_RichText__Aeod3 .RichText_enSupport__0jiYn {
  direction: ltr;
  text-align: left;
}
.RichText_RichText__Aeod3 .RichText_arSupport__ZhRUa {
  direction: rtl;
  text-align: right;
}
.RichText_RichText__Aeod3 .RichText_arSupport__ZhRUa li::before {
  margin-left: 0 !important;
  margin-right: 3.5em !important;
}
.RichText_RichText__Aeod3 .RichText_reactDraft__qHnRO .RichText_rdw-editor-toolbar__lR0kO .RichText_rdw-dropdown-carettoopen__xPwHf {
  right: 10% !important;
}
.RichText_RichText__Aeod3 .reactDraft .DraftEditor-editorContainer {
  padding-inline: 20px;
}
.RichText_RichText__Aeod3 .reactDraft .rdw-link-decorator-wrapper a {
  color: var(--secondaryColor);
  text-decoration: underline;
}
.RichText_RichText__Aeod3 .reactDraft .rdw-link-modal {
  height: 260px;
  padding-block: 20px;
}
.RichText_RichText__Aeod3 .reactDraft .rdw-link-modal label {
  color: var(--secondaryColor);
}
.RichText_RichText__Aeod3 .reactDraft .rdw-link-modal .rdw-link-modal-target-option {
  display: flex;
  align-items: center;
}
.RichText_RichText__Aeod3 .reactDraft .rdw-link-modal .rdw-link-modal-target-option input {
  margin-inline: 5px;
  margin-top: 5px;
}
.RichText_RichText__Aeod3 .reactDraft .public-DraftStyleDefault-ul ::marker {
  display: none !important;
}
.RichText_RichText__Aeod3 .reactDraft .public-DraftStyleDefault-ol li {
  counter-increment: ol0;
}
.RichText_RichText__Aeod3 .reactDraft .public-DraftStyleDefault-ol li::before {
  content: none;
}
.RichText_RichText__Aeod3 .reactDraft .public-DraftStyleDefault-ol .rdw-right-aligned-block .public-DraftStyleDefault-ltr::before {
  content: none !important;
}
.RichText_RichText__Aeod3 .reactDraft .public-DraftStyleDefault-ol .rdw-right-aligned-block .public-DraftStyleDefault-ltr::after {
  content: counter(ol0) ". ";
  margin-inline: 5px;
}
.RichText_RichText__Aeod3 .reactDraft .public-DraftStyleDefault-ol li {
  list-style-type: none;
}
.RichText_RichText__Aeod3 .reactDraft .public-DraftStyleDefault-ol li .public-DraftStyleDefault-ltr::before {
  content: counter(ol0) ". ";
  margin-inline: 5px;
}
.RichText_RichText__Aeod3 .reactDraft .public-DraftStyleDefault-ul {
  list-style-type: none;
}
.RichText_RichText__Aeod3 .reactDraft .public-DraftStyleDefault-ul .rdw-right-aligned-block .public-DraftStyleDefault-ltr::before {
  content: none !important;
}
.RichText_RichText__Aeod3 .reactDraft .public-DraftStyleDefault-ul .rdw-right-aligned-block .public-DraftStyleDefault-ltr::after {
  content: "•";
  margin-inline: 5px;
}
.RichText_RichText__Aeod3 .reactDraft .public-DraftStyleDefault-ul li {
  list-style-type: none;
}
.RichText_RichText__Aeod3 .reactDraft .public-DraftStyleDefault-ul li .public-DraftStyleDefault-ltr::before {
  content: " •";
  margin-inline: 5px;
}
.RichText_RichText__Aeod3 .reactDraft .public-DraftStyleDefault-unorderedListItem li {
  list-style-type: none;
}
.RichText_RichText__Aeod3 .reactDraft .public-DraftStyleDefault-block {
  margin: 0.5em 0;
}
.RichText_RichText__Aeod3 .reactDraft .rdw-image-modal,
.RichText_RichText__Aeod3 .reactDraft .rdw-link-modal,
.RichText_RichText__Aeod3 .reactDraft .rdw-colorpicker-modal {
  background-color: var(--bgColor);
  box-shadow: none;
}
.RichText_RichText__Aeod3 .reactDraft .rdw-link-modal .rdw-link-modal-btn:first-child {
  color: var(--bgColor);
  background-color: var(--secondaryColor);
}
.RichText_RichText__Aeod3 .reactDraft .rdw-link-modal .rdw-link-modal-btn {
  background-color: var(--bgColor);
  color: var(--mainColor);
}
.RichText_RichText__Aeod3 .reactDraft .rdw-image-modal {
  height: 245px;
  width: 280px;
}
.RichText_RichText__Aeod3 .reactDraft .rdw-image-modal .rdw-image-modal-upload-option-label {
  background-color: var(--bgColor);
  font-size: 9px;
}
.RichText_RichText__Aeod3 .reactDraft .rdw-image-modal .rdw-image-modal-btn {
  background-color: var(--bgColor);
  color: var(--mainColor);
}
.RichText_RichText__Aeod3 .reactDraft .rdw-image-modal .rdw-image-modal-btn:first-child {
  color: var(--bgColor);
  background-color: var(--secondaryColor);
}
.RichText_RichText__Aeod3 .reactDraft .rdw-dropdownoption-active {
  background: var(--secondaryColor) !important;
}
.RichText_RichText__Aeod3 .reactDraft .rdw-dropdown-optionwrapper {
  border: 1px solid var(--borderColor) !important;
}
.RichText_RichText__Aeod3 .reactDraft .rdw-dropdown-optionwrapper .rdw-dropdownoption-disabled {
  background-color: var(--bgColor);
  opacity: 0.7;
}
.RichText_RichText__Aeod3 .reactDraft .rdw-dropdownoption-default {
  background: var(--bgColor);
}
.RichText_RichText__Aeod3 .reactDraft div {
  padding-block: 0px;
}
body[dir=rtl] .RichText_RichText__Aeod3 .reactDraft .rdw-editor-toolbar .rdw-dropdown-carettoopen {
  right: auto !important;
  right: initial !important;
  left: 10% !important;
}
body[dir=rtl] .RichText_RichText__Aeod3 .reactDraft .rdw-editor-toolbar .rdw-dropdown-carettoclose {
  right: auto !important;
  right: initial !important;
  left: 10% !important;
}
.RichText_RichText__Aeod3 .reactDraft .rdw-dropdown-selectedtext span {
  color: black;
}
.RichText_RichText__Aeod3 .quill {
  height: 130px;
  background-color: var(--bgColor);
}
.RichText_RichText__Aeod3 .quill .ql-container {
  background-color: var(--bgColor);
}
.RichText_RichText__Aeod3 .quill .ql-toolbar {
  direction: ltr;
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}
.RichText_RichText__Aeod3 .quill .ql-size {
  margin-top: 8px;
}
.RichText_RichText__Aeod3 .quill .ql-formats {
  display: flex;
  align-items: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/app/components/RichText/RichText.module.scss","webpack://./src/app/assets/scss/vars.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACKhB;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ADHF;ACMA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ADJF;ACMA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ADJF;ACMA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ADJF;ACOA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ADLF;ACQA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ADNF;ACSA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ADPF;ACUA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ADRF;ACWA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ADTF;AC0HE;EACE,WAAA;ADxHJ;AC2HE;EACE,kCAAA;ADzHJ;AC4HE;EACE,kCAAA;AD1HJ;;AApDA;EACE,2BAAA;EAAA,mBAAA;AAuDF;AArDI;EACE,4BAAA;AAuDN;AAtDM;EACE,wBAAA;AAwDR;AApDE;EACE,wBAAA;AAsDJ;AAnDE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,OAAA;AAqDJ;AApDI;;EAEE,mBAAA;EACA,0BAAA;EACA,iBAAA;AAsDN;AApDI;EACE,0BAAA;AAsDN;AApDI;EACE,wBAAA;AAsDN;AAnDE;EACE,cAAA;EACA,gBAAA;AAqDJ;AAnDE;EACE,cAAA;EACA,iBAAA;AAqDJ;AApDI;EACE,yBAAA;EACA,8BAAA;AAsDN;AAjDM;EACE,qBAAA;AAmDR;AA7CM;EACE,oBAAA;AA+CR;AA5CQ;EACE,4BAAA;EACA,0BAAA;AA8CV;AA3CM;EACE,aAAA;EACA,mBAAA;AA6CR;AA5CQ;EACE,4BAAA;AA8CV;AA5CQ;EACE,aAAA;EACA,mBAAA;AA8CV;AA7CU;EACE,kBAAA;EACA,eAAA;AA+CZ;AA3CM;EACE,wBAAA;AA6CR;AA1CQ;EACE,sBAAA;AA4CV;AA1CQ;EACE,aAAA;AA4CV;AAzCU;EACE,wBAAA;AA2CZ;AAzCU;EACE,0BAAA;EACA,kBAAA;AA2CZ;AAxCQ;EACE,qBAAA;AA0CV;AAzCU;EACE,0BAAA;EACA,kBAAA;AA2CZ;AAtCM;EACE,qBAAA;AAwCR;AAtCU;EACE,wBAAA;AAwCZ;AAtCU;EACE,YAAA;EACA,kBAAA;AAwCZ;AArCQ;EACE,qBAAA;AAuCV;AAtCU;EACE,aAAA;EACA,kBAAA;AAwCZ;AAnCM;EACE,qBAAA;AAqCR;AAvBM;EACE,eAAA;AAyBR;AAvBM;;;EAGE,gCAAA;EACA,gBAAA;AAyBR;AAtBQ;EACE,qBAAA;EACA,uCAAA;AAwBV;AAtBQ;EACE,gCAAA;EACA,uBAAA;AAwBV;AArBM;EACE,aAAA;EACA,YAAA;AAuBR;AAtBQ;EACE,gCAAA;EACA,cAAA;AAwBV;AAtBQ;EACE,gCAAA;EACA,uBAAA;AAwBV;AAtBQ;EACE,qBAAA;EACA,uCAAA;AAwBV;AApBM;EACE,4CAAA;AAsBR;AApBM;EACE,+CAAA;AAsBR;AArBQ;EACE,gCAAA;EACA,YAAA;AAuBV;AApBM;EACE,0BAAA;AAsBR;AApBM;EACE,kBAAA;AAsBR;AAjBU;EACE,sBAAA;EAAA,yBAAA;EACA,oBAAA;AAmBZ;AAfU;EACE,sBAAA;EAAA,yBAAA;EACA,oBAAA;AAiBZ;AAZQ;EACE,YAAA;AAcV;AAVI;EACE,aAAA;EACA,gCAAA;AAYN;AAVM;EACE,gCAAA;AAYR;AATM;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AAWR;AATM;EACE,eAAA;AAWR;AATM;EACE,aAAA;EACA,qBAAA;AAWR","sourcesContent":["@import 'app/assets/scss/vars.scss';\r\n\r\n.RichText {\r\n  height: fit-content;\r\n  &:focus-within {\r\n    label {\r\n      color: var(--secondaryColor);\r\n      &.LabelError {\r\n        color: var(--errorColor);\r\n      }\r\n    }\r\n  }\r\n  .LabelError {\r\n    color: var(--errorColor);\r\n  }\r\n\r\n  .label_required {\r\n    display: flex;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 10;\r\n    label,\r\n    p {\r\n      margin-bottom: 10px;\r\n      font-size: 12px !important;\r\n      line-height: 15px;\r\n    }\r\n    label {\r\n      text-transform: capitalize;\r\n    }\r\n    p {\r\n      color: var(--errorColor);\r\n    }\r\n  }\r\n  .enSupport {\r\n    direction: ltr;\r\n    text-align: left;\r\n  }\r\n  .arSupport {\r\n    direction: rtl;\r\n    text-align: right;\r\n    li::before {\r\n      margin-left: 0 !important;\r\n      margin-right: 3.5em !important;\r\n    }\r\n  }\r\n  .reactDraft {\r\n    .rdw-editor-toolbar {\r\n      .rdw-dropdown-carettoopen {\r\n        right: 10% !important;\r\n      }\r\n    }\r\n  }\r\n  :global {\r\n    .reactDraft {\r\n      .DraftEditor-editorContainer {\r\n        padding-inline: 20px;\r\n      }\r\n      .rdw-link-decorator-wrapper {\r\n        a {\r\n          color: var(--secondaryColor);\r\n          text-decoration: underline;\r\n        }\r\n      }\r\n      .rdw-link-modal {\r\n        height: 260px;\r\n        padding-block: 20px;\r\n        label {\r\n          color: var(--secondaryColor);\r\n        }\r\n        .rdw-link-modal-target-option {\r\n          display: flex;\r\n          align-items: center;\r\n          input {\r\n            margin-inline: 5px;\r\n            margin-top: 5px;\r\n          }\r\n        }\r\n      }\r\n      .public-DraftStyleDefault-ul ::marker {\r\n        display: none !important;\r\n      }\r\n      .public-DraftStyleDefault-ol {\r\n        li {\r\n          counter-increment: ol0;\r\n        }\r\n        li::before {\r\n          content: none;\r\n        }\r\n        .rdw-right-aligned-block {\r\n          .public-DraftStyleDefault-ltr::before {\r\n            content: none !important;\r\n          }\r\n          .public-DraftStyleDefault-ltr::after {\r\n            content: counter(ol0) '. ';\r\n            margin-inline: 5px;\r\n          }\r\n        }\r\n        li {\r\n          list-style-type: none;\r\n          .public-DraftStyleDefault-ltr::before {\r\n            content: counter(ol0) '. ';\r\n            margin-inline: 5px;\r\n          }\r\n        }\r\n      }\r\n\r\n      .public-DraftStyleDefault-ul {\r\n        list-style-type: none;\r\n        .rdw-right-aligned-block {\r\n          .public-DraftStyleDefault-ltr::before {\r\n            content: none !important;\r\n          }\r\n          .public-DraftStyleDefault-ltr::after {\r\n            content: '\\2022';\r\n            margin-inline: 5px;\r\n          }\r\n        }\r\n        li {\r\n          list-style-type: none;\r\n          .public-DraftStyleDefault-ltr::before {\r\n            content: ' \\2022';\r\n            margin-inline: 5px;\r\n          }\r\n        }\r\n      }\r\n\r\n      .public-DraftStyleDefault-unorderedListItem li {\r\n        list-style-type: none;\r\n      }\r\n      // .public-DraftStyleDefault-unorderedListItem {\r\n      //   .public-DraftStyleDefault-block ::before {\r\n      //     content: '*';\r\n      //   }\r\n      // }\r\n\r\n      // .public-DraftStyleDefault-listLTR {\r\n      //   direction: ltr;\r\n      // }\r\n      // .public-DraftStyleDefault-listRTL {\r\n      //   direction: rtl;\r\n      // }\r\n      .public-DraftStyleDefault-block {\r\n        margin: 0.5em 0;\r\n      }\r\n      .rdw-image-modal,\r\n      .rdw-link-modal,\r\n      .rdw-colorpicker-modal {\r\n        background-color: var(--bgColor);\r\n        box-shadow: none;\r\n      }\r\n      .rdw-link-modal{\r\n        .rdw-link-modal-btn:first-child{\r\n          color: var(--bgColor);\r\n          background-color: var(--secondaryColor);\r\n        }\r\n        .rdw-link-modal-btn{\r\n          background-color: var(--bgColor);\r\n          color: var(--mainColor);\r\n        }\r\n      }\r\n      .rdw-image-modal{\r\n        height: 245px;\r\n        width: 280px;\r\n        .rdw-image-modal-upload-option-label {\r\n          background-color: var(--bgColor);\r\n          font-size: 9px;\r\n        }\r\n        .rdw-image-modal-btn{\r\n          background-color: var(--bgColor);\r\n          color: var(--mainColor);\r\n        }\r\n        .rdw-image-modal-btn:first-child{\r\n          color: var(--bgColor);\r\n          background-color: var(--secondaryColor);\r\n        }\r\n\r\n      }\r\n      .rdw-dropdownoption-active {\r\n        background: var(--secondaryColor) !important;\r\n      }\r\n      .rdw-dropdown-optionwrapper {\r\n        border: 1px solid var(--borderColor) !important;\r\n        .rdw-dropdownoption-disabled{\r\n          background-color: var(--bgColor);\r\n          opacity: 0.7;\r\n        }\r\n      }\r\n      .rdw-dropdownoption-default {\r\n        background: var(--bgColor);\r\n      }\r\n      div {\r\n        padding-block: 0px;\r\n        // background-color: var(--bgColor);\r\n      }\r\n      .rdw-editor-toolbar {\r\n        .rdw-dropdown-carettoopen {\r\n          #{$rtl} & {\r\n            right: unset !important;\r\n            left: 10% !important;\r\n          }\r\n        }\r\n        .rdw-dropdown-carettoclose {\r\n          #{$rtl} & {\r\n            right: unset !important;\r\n            left: 10% !important;\r\n          }\r\n        }\r\n      }\r\n      .rdw-dropdown-selectedtext {\r\n        span {\r\n          color: black;\r\n        }\r\n      }\r\n    }\r\n    .quill {\r\n      height: 130px;\r\n      background-color: var(--bgColor);\r\n\r\n      .ql-container {\r\n        background-color: var(--bgColor);\r\n      }\r\n\r\n      .ql-toolbar {\r\n        direction: ltr;\r\n        text-align: left;\r\n        display: flex;\r\n        flex-wrap: wrap;\r\n        align-items: flex-end;\r\n      }\r\n      .ql-size {\r\n        margin-top: 8px;\r\n      }\r\n      .ql-formats {\r\n        display: flex;\r\n        align-items: flex-end;\r\n      }\r\n    }\r\n  }\r\n}\r\n","//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `RichText_scroll__2JakK`,
	"RichText": `RichText_RichText__Aeod3`,
	"LabelError": `RichText_LabelError__KEPk-`,
	"label_required": `RichText_label_required__7+MBb`,
	"enSupport": `RichText_enSupport__0jiYn`,
	"arSupport": `RichText_arSupport__ZhRUa`,
	"reactDraft": `RichText_reactDraft__qHnRO`,
	"rdw-editor-toolbar": `RichText_rdw-editor-toolbar__lR0kO`,
	"rdw-dropdown-carettoopen": `RichText_rdw-dropdown-carettoopen__xPwHf`
};
export default ___CSS_LOADER_EXPORT___;
